import { Injectable } from '@angular/core';
import { logAction, Store, StoreConfig } from '@datorama/akita';
import { Address, TransactionReceipt } from 'viem';

export interface Web3State {
  isTransaction: boolean;
  isFetchingData: boolean;
  txReceipt: Partial<TransactionReceipt> | null;
  successMessageKey: string;
  errorMessageKey: string;
  adapterEvents: 'disconnected' | 'connected';
  loginModalVisibility: boolean;
  error: any;
  hasEthProvider: boolean;
  chainId: number | null;
  address: Address | null;
  accounts: Address[];
}

export function createInitialState(): Web3State {
  return {
    isTransaction: false,
    isFetchingData: false,
    txReceipt: null,
    successMessageKey: '',
    errorMessageKey: '',
    adapterEvents: 'disconnected',
    loginModalVisibility: false,
    error: null,
    hasEthProvider: false,
    chainId: null,
    address: null,
    accounts: [],
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'web3-transaction', resettable: true })
export class Web3Store extends Store<Web3State> {
  constructor() {
    super(createInitialState());
  }

  setIsTransaction(isTransaction: boolean) {
    logAction('Set is transaction');
    this.update({ isTransaction });
  }

  setTxReceipt(txReceipt: Partial<TransactionReceipt>) {
    logAction('Set is transaction receipt');
    this.update({ txReceipt });
  }

  setTxHash(hash: `0x${string}`) {
    logAction('Set tx hash');
    this.update((state) => ({
      ...state,
      txReceipt: {
        ...state.txReceipt,
        transactionHash: hash,
      },
    }));
  }

  setIsFetchingData(isFetchingData: boolean) {
    logAction('Set is fetching data');
    this.update({ isFetchingData });
  }

  resetLastTransaction() {
    const init = createInitialState();
    logAction('Reset last transaction');
    this.update({
      isTransaction: init.isTransaction,
      isFetchingData: init.isFetchingData,
      successMessageKey: init.successMessageKey,
      error: init.error,
      errorMessageKey: init.errorMessageKey,
    });
  }
}
